export enum WsMessageType {
    CHANNEL_INFO = 'channelInfo',
    USER_INFO = 'userInfo',
    CHAT_DATA = 'CHAT_DATA',
}
